
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("eSNAw", function(module, exports) {
const $ad5c92fa44bc526b$var$textAndMediaSliderGroups = document.querySelectorAll(".g-text-and-media-slider");
$ad5c92fa44bc526b$var$textAndMediaSliderGroups.forEach((group)=>{
    const prevButton = group.querySelector(".g-text-and-media-slider__button.--prev");
    const nextButton = group.querySelector(".g-text-and-media-slider__button.--next");
    const medias = group.querySelectorAll(".g-text-and-media-slider__media-item");
    const contents = group.querySelectorAll(".g-text-and-media-slider__content-item");
    if (!prevButton || !nextButton) return;
    const numberOfItems = parseInt(group.dataset.items ?? "0");
    if (!numberOfItems) return;
    let activeIndex = 0;
    let delay = false;
    const openGroupItem = (index)=>{
        medias.forEach((media)=>{
            media.classList.toggle("--open", media.dataset.index === `${index}`);
        });
        contents.forEach((content)=>{
            content.classList.toggle("--open", content.dataset.index === `${index}`);
        });
        delay = true;
        setTimeout(()=>delay = false, 500);
    };
    prevButton.addEventListener("click", (e)=>{
        e.preventDefault();
        if (delay) return;
        if (activeIndex == 0) activeIndex = numberOfItems - 1;
        else activeIndex--;
        openGroupItem(activeIndex);
    });
    nextButton.addEventListener("click", (e)=>{
        e.preventDefault();
        if (delay) return;
        if (activeIndex == numberOfItems - 1) activeIndex = 0;
        else activeIndex++;
        openGroupItem(activeIndex);
    });
    contents.forEach((content)=>{
        content.addEventListener("click", ()=>{
            if (delay) return;
            if (content.classList.contains("--open")) return;
            activeIndex = parseInt(content.dataset.index ?? "0");
            openGroupItem(activeIndex);
        });
    });
    openGroupItem(activeIndex);
});

});


//# sourceMappingURL=text-and-media-slider-group.5a2463df.js.map
